module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-04.2cbd4f38.png";